(function () {
  if (window.LeibishAiChatLoaded) return;
  window.LeibishAiChatLoaded = true;

  var STORAGE_KEY         = 'leibish_ai_chat_messages';
  var STORAGE_EXPIRY_KEY  = 'leibish_ai_chat_expiry';
  var SESSION_TTL         = 24 * 60 * 60 * 1000; // 24 hours
  var MAX_STORED_MESSAGES = 10;
  var LAST_SHOWN_LIMIT    = 8;

  /* ── Storage ──────────────────────────────────────── */

  function getStoredMessages() {
    try {
      var expiry = localStorage.getItem(STORAGE_EXPIRY_KEY);
      if (expiry && Date.now() > Number(expiry)) {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_EXPIRY_KEY);
        return [];
      }
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed.map(function (m) {
        return {
          role:     m && m.role === 'user' ? 'user' : 'assistant',
          content:  String((m && m.content) || '').trim(),
          products: Array.isArray(m && m.products) ? m.products : [],
          actions:  Array.isArray(m && m.actions)  ? m.actions  : [],
          productContextType: String((m && m.productContextType) || '')
        };
      }).filter(function (m) { return m.content; }).slice(-MAX_STORED_MESSAGES);
    } catch (e) { return []; }
  }

  function storeMessages(messages) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(messages.slice(-MAX_STORED_MESSAGES)));
      localStorage.setItem(STORAGE_EXPIRY_KEY, String(Date.now() + SESSION_TTL));
    } catch (e) {}
  }

  function clearStorage() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_EXPIRY_KEY);
    } catch (e) {}
  }

  /* ── Translations ─────────────────────────────────── */

  function parseTranslations(root) {
    var script = root.querySelector('.leibish-ai-chat__translations');
    if (!script) return {};
    try { return JSON.parse(script.textContent || '{}'); } catch (e) { return {}; }
  }

  /* ── Rendering helpers ────────────────────────────── */

  function appendTextWithLinks(target, text) {
    var value = String(text || '');
    var parts = value.split(/(https?:\/\/[^\s<]+)/g);
    parts.forEach(function (part) {
      if (!part) return;
      if (/^https?:\/\//i.test(part)) {
        var link = document.createElement('a');
        link.href = part.replace(/[),.]+$/, '');
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = link.href;
        target.appendChild(link);
        var trailing = part.slice(link.href.length);
        if (trailing) target.appendChild(document.createTextNode(trailing));
        return;
      }
      var lines = part.split('\n');
      lines.forEach(function (line, i) {
        if (i > 0) target.appendChild(document.createElement('br'));
        target.appendChild(document.createTextNode(line));
      });
    });
  }

  function formatProductPrice(root, product) {
    var amount   = Number(product && product.price);
    var currency = (product && product.currency) || root.dataset.currency || 'USD';
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (e) { return currency + ' ' + amount.toLocaleString(); }
  }

  function getProductActions(product, actions) {
    return (actions || []).filter(function (a) {
      return (
        (a.productId      && a.productId      === product.productId)
        || (a.variantId   && a.variantId      === product.variantId)
        || (a.merchandiseId && a.merchandiseId === product.merchandiseId)
      );
    });
  }

  function getAvailabilityLabel(product) {
    if (product.settingDyo) return 'DYO setting';
    if (product.availableForSale === false || product.sellableOnlineQuantity === 0) return 'Unavailable online';
    if (product.cartIneligibleReason) return product.cartIneligibleReason;
    return 'Available online';
  }

  function announceCartChange(cart) {
    try {
      document.dispatchEvent(new CustomEvent('leibish:ai-chat:add-to-cart', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (e) {}
  }

  async function addActionToCart(button, action) {
    if (!action || action.disabled || !action.variantNumericId) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      var response = await fetch(button.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(action.variantNumericId),
          quantity: Number(action.quantity || 1)
        })
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');

      button.textContent = 'Added to cart';
      button.classList.add('leibish-ai-chat__product-button--success');
      announceCartChange(data);
    } catch (error) {
      console.warn('[Leibish AI Chat] Add to cart failed', error);
      button.textContent = 'Could not add';
      button.title = error.message || 'Could not add to cart';
      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1800);
    }
  }

  function renderProductCard(root, product, actions) {
    var productActions = getProductActions(product, actions);
    var viewAction = productActions.find(function (a) { return a.type === 'VIEW_PRODUCT' && !a.disabled && a.url; });
    var addAction = productActions.find(function (a) { return a.type === 'ADD_TO_CART'; });

    var card  = document.createElement('article');
    var body  = document.createElement('div');
    var title = document.createElement('h3');
    var meta  = document.createElement('p');
    var status = document.createElement('p');
    var actionsEl = document.createElement('div');
    var price = formatProductPrice(root, product);
    var metaParts = [];

    card.className      = 'leibish-ai-chat__product';
    body.className      = 'leibish-ai-chat__product-body';
    title.className     = 'leibish-ai-chat__product-title';
    meta.className      = 'leibish-ai-chat__product-meta';
    status.className    = 'leibish-ai-chat__product-status';
    actionsEl.className = 'leibish-ai-chat__product-actions';
    title.textContent   = product.title || 'Leibish product';

    if (product.image) {
      var img = document.createElement('img');
      img.className = 'leibish-ai-chat__product-image';
      img.src = product.image; img.alt = product.title || ''; img.loading = 'lazy';
      card.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'leibish-ai-chat__product-image'; ph.setAttribute('aria-hidden', 'true');
      card.appendChild(ph);
    }

    if (product.sku) metaParts.push('SKU: ' + product.sku);
    if (price)       metaParts.push(price);
    meta.textContent   = metaParts.join('  ·  ');
    status.textContent = getAvailabilityLabel(product);

    if (product.cartIneligibleReason || product.availableForSale === false || product.sellableOnlineQuantity === 0) {
      status.className += ' leibish-ai-chat__product-status--blocked';
    }

    body.appendChild(title);
    if (meta.textContent) body.appendChild(meta);
    body.appendChild(status);

    if (viewAction || product.url) {
      var link = document.createElement('a');
      link.className  = 'leibish-ai-chat__product-link';
      link.href       = viewAction ? viewAction.url : product.url;
      link.target     = '_blank';
      link.rel        = 'noopener noreferrer';
      link.textContent = 'View piece';
      actionsEl.appendChild(link);
    }

    if (addAction) {
      var addButton = document.createElement('button');
      addButton.className = 'leibish-ai-chat__product-link leibish-ai-chat__product-button';
      addButton.type = 'button';
      addButton.dataset.cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
      addButton.textContent = addAction.disabled ? 'Contact specialist' : 'Add to cart';
      addButton.disabled = Boolean(addAction.disabled);
      if (addAction.reason) addButton.title = addAction.reason;
      addButton.addEventListener('click', function () { addActionToCart(addButton, addAction); });
      actionsEl.appendChild(addButton);
    }

    if (actionsEl.childNodes.length) body.appendChild(actionsEl);

    card.appendChild(body);
    return card;
  }

  function renderProducts(root, target, message) {
    var products = Array.isArray(message.products) ? message.products : [];
    if (!products.length || message.role === 'user') return;
    var list = document.createElement('div');
    list.className = 'leibish-ai-chat__products';
    products.forEach(function (p) { list.appendChild(renderProductCard(root, p, message.actions || [])); });
    target.appendChild(list);
  }

  function renderMessage(messagesEl, message, options) {
    var root = options && options.root;
    var bubble = document.createElement('div');
    var role = message.role === 'user' ? 'user' : 'assistant';
    bubble.className = 'leibish-ai-chat__message leibish-ai-chat__message--' + role;
    appendTextWithLinks(bubble, message.content);
    if (root && role === 'assistant') renderProducts(root, bubble, message);
    messagesEl.appendChild(bubble);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return bubble;
  }

  function renderThinking(messagesEl) {
    var bubble = document.createElement('div');
    bubble.className = 'leibish-ai-chat__message leibish-ai-chat__message--assistant leibish-ai-chat__message--thinking';
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'leibish-ai-chat__dot';
      bubble.appendChild(dot);
    }
    messagesEl.appendChild(bubble);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return bubble;
  }

  /* ── Context ──────────────────────────────────────── */

  function getContext(root) {
    return {
      pageUrl:           window.location.href,
      pageTitle:         root.dataset.pageTitle  || document.title,
      pageType:          root.dataset.pageType   || '',
      productHandle:     root.dataset.productHandle   || '',
      collectionHandle:  root.dataset.collectionHandle || '',
      locale:            root.dataset.locale     || '',
      currency:          root.dataset.currency   || '',
      cartItemCount:     root.dataset.cartItemCount || ''
    };
  }

  function getConversationState(messages) {
    var lastAssistantWithProducts = messages
      .slice()
      .reverse()
      .find(function (m) {
        return m.role === 'assistant' && Array.isArray(m.products) && m.products.length;
      });

    return {
      lastProductContextType: lastAssistantWithProducts ? lastAssistantWithProducts.productContextType || '' : '',
      lastShownProducts: lastAssistantWithProducts
        ? lastAssistantWithProducts.products.slice(0, LAST_SHOWN_LIMIT).map(function (p, index) {
            return {
              index: index + 1,
              productId: p.productId,
              variantId: p.variantId,
              merchandiseId: p.merchandiseId,
              variantNumericId: p.variantNumericId,
              title: p.title,
              handle: p.handle,
              productType: p.productType,
              status: p.status,
              sku: p.sku,
              price: p.price,
              currency: p.currency,
              url: p.url,
              image: p.image,
              availableForSale: p.availableForSale,
              sellableOnlineQuantity: p.sellableOnlineQuantity,
              restricted: p.restricted,
              callForPrice: p.callForPrice,
              reserved: p.reserved,
              settingDyo: p.settingDyo,
              attributes: p.attributes || {},
              tags: p.tags || [],
              description: p.description || '',
              cartEligible: p.cartEligible,
              cartIneligibleReason: p.cartIneligibleReason
            };
          })
        : []
    };
  }

  /* ── Panel animation ──────────────────────────────── */

  function openPanel(panel, launcher, input) {
    panel.hidden = false;
    panel.classList.remove('leibish-ai-chat__panel--leaving');
    launcher.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (input) input.focus(); }, 50);
  }

  function closePanel(panel, launcher) {
    panel.classList.add('leibish-ai-chat__panel--leaving');
    launcher.setAttribute('aria-expanded', 'false');
    function onEnd() {
      panel.hidden = true;
      panel.classList.remove('leibish-ai-chat__panel--leaving');
    }
    panel.addEventListener('animationend', onEnd, { once: true });
    launcher.focus();
  }

  /* ── Init ─────────────────────────────────────────── */

  function initChat(root) {
    var launcher      = root.querySelector('.leibish-ai-chat__launcher');
    var panel         = root.querySelector('.leibish-ai-chat__panel');
    var closeButton   = root.querySelector('.leibish-ai-chat__close');
    var newChatButton = root.querySelector('.leibish-ai-chat__new');
    var messagesEl    = root.querySelector('.leibish-ai-chat__messages');
    var form          = root.querySelector('.leibish-ai-chat__form');
    var input         = root.querySelector('.leibish-ai-chat__input');
    var sendButton    = root.querySelector('.leibish-ai-chat__send');
    var translations  = parseTranslations(root);
    var apiUrl        = root.dataset.apiUrl;
    var messages      = getStoredMessages();
    var isSending     = false;

    function redrawMessages() {
      messagesEl.textContent = '';
      messages.forEach(function (m) { renderMessage(messagesEl, m, { root: root }); });
    }

    function addMessage(role, content, extra) {
      var message = {
        role:     role,
        content:  String(content || '').trim(),
        products: Array.isArray(extra && extra.products) ? extra.products : [],
        actions:  Array.isArray(extra && extra.actions)  ? extra.actions  : [],
        productContextType: String((extra && extra.productContextType) || '')
      };
      if (!message.content) return null;
      messages.push(message);
      messages = messages.slice(-MAX_STORED_MESSAGES);
      storeMessages(messages);
      renderMessage(messagesEl, message, { root: root });
      return message;
    }

    function getRequestMessages() {
      return messages.map(function (m) { return { role: m.role, content: m.content }; }).slice(-MAX_STORED_MESSAGES);
    }

    function startGreeting() {
      messages = [];
      if (translations.greeting) {
        messages = [{ role: 'assistant', content: translations.greeting, products: [], actions: [], productContextType: '' }];
        storeMessages(messages);
      }
      redrawMessages();
    }

    async function sendMessage(content) {
      if (isSending) return;
      if (!apiUrl) { addMessage('assistant', translations.error || 'Chat is temporarily unavailable.'); return; }

      isSending = true;
      sendButton.disabled = true;
      input.disabled = true;

      addMessage('user', content);
      var thinkingBubble = renderThinking(messagesEl);

      try {
        var response = await fetch(apiUrl, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            messages: getRequestMessages(),
            context: getContext(root),
            state: getConversationState(messages)
          })
        });
        var data = await response.json().catch(function () { return {}; });
        thinkingBubble.remove();

        if (!response.ok || !data.success) throw new Error(data.error || 'Chat request failed');

        addMessage('assistant', data.reply || translations.empty || 'I could not find an answer.', {
          products: Array.isArray(data.products) ? data.products : [],
          actions:  Array.isArray(data.actions)  ? data.actions  : [],
          productContextType: data.productContextType || ''
        });
      } catch (error) {
        console.warn('[Leibish AI Chat] Request failed', error);
        thinkingBubble.remove();
        addMessage('assistant', translations.error || 'Chat is temporarily unavailable.');
      } finally {
        isSending = false;
        sendButton.disabled = false;
        input.disabled = false;
        input.focus();
      }
    }

    /* Seed greeting if no stored history */
    if (!messages.length) startGreeting();
    else redrawMessages();

    /* ── Event listeners ────────────────────────────── */

    launcher.addEventListener('click', function () {
      if (panel.hidden) openPanel(panel, launcher, input);
      else closePanel(panel, launcher);
    });

    closeButton.addEventListener('click', function () { closePanel(panel, launcher); });

    if (newChatButton) {
      newChatButton.addEventListener('click', function () {
        clearStorage();
        startGreeting();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = input.value.trim();
      if (!value) return;
      input.value = '';
      sendMessage(value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) closePanel(panel, launcher);
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    var root = document.getElementById('LeibishAiChat');
    if (root) initChat(root);
  });
})();
